export const UPLOAD_GALLERY_BUTTON_CONSTS = {
  fillRequiredFields: 'Заполните обязательные поля',
  uploadGallery: 'Загрузить галерею',
  uploadGalleryTooltip: 'Загрузить галерею по указанной ссылке'
}
